<template>
    <section class="section virtual-panel">
        <div class="tabs-bar">
            <div @click="tabSelected = 'list'" class="tab" :class="tabSelected == 'list' ? 'tab-selected' : ''">Utenze</div>
            <div @click="openCalendar()" class="tab" :class="tabSelected == 'calendar' ? 'tab-selected' : ''">Calendario</div>
            <div @click="tabSelected = 'correction'" class="tab" :class="tabSelected == 'correction' ? 'tab-selected' : ''">Correzioni</div>
        </div>

        <!-- <input
            v-if="tabSelected == 'list' && rows && rows.length > 0"
            type="text"
            class="form-control mb-4"
            placeholder="Cerca..."
            v-model="filterVirtual"
            @input="filterList"
        /> -->

        <div class="row">
            <div class="col">
                <!-- Utenze -->
                <div v-if="tabSelected == 'list'">
                    <b-alert :show="filteredRows && filteredRows.length == 0 && rows && rows.length > 0">
                        Nessun calendario trovato con "{{ filterVirtual }}".
                    </b-alert>
                    <b-alert :show="rows && rows.length == 0">
                        Nessun calendario inserito.
                    </b-alert>
                    <div v-if="rows && rows.length > 10" class="d-flex justify-content-end mb-2">
                        <b-btn variant="primary" class="mr-2" @click="openUploadModal()">Importa CSV</b-btn>
                        <!--<b-btn variant="primary" class="mr-2" @click="exportVirtual()">Esporta CSV</b-btn-->
                        <b-btn variant="warning" class="mr-2" @click="openEditModal()">Aggiungi utenza</b-btn>
                        <b-btn variant="primary" @click="openBulkModal()" :disabled="bulkChannels.length == 0">Operazioni bulk</b-btn>
                    </div>
                    <vue-good-table
                        :select-options="{ enabled: true, }"
                              :search-options="{ enabled: true }" 
                              :pagination-options="{
                                  enabled: true,
                                  position: 'bottom',
                                  perPageDropdown: [20, 50, 100],
                                  dropdownAllowAll: true,
                                  setCurrentPage: 1,
                                  jumpFirstOrLast: true,
                                  firstLabel: 'Prima pagina',
                                  lastLabel: 'Ultima pagina',
                                  nextLabel: 'Successiva',
                                  prevLabel: 'Precedente',
                                  rowsPerPageLabel: 'Canali per pagina',
                                  ofLabel: 'of',
                                  pageLabel: 'page', // for 'pages' mode
                                  allLabel: 'tutti',
                              }"
                        @on-selected-rows-change="selectedRowsChange"
                        v-if="filteredRows && filteredRows.length > 0"
                        :columns="columns"
                        :rows="filteredRows"
                        :sort-options="{
                            enabled: true,
                            initialSortBy: { field: 'name', type: 'asc' }
                        }"
                    >
                        <template #table-row="props">
                            <span v-if="props.column.field == 'name'">
                                <div style="display: grid">
                                    <span>{{ props.row.name }}</span>
                                </div>
                            </span>
                            <span v-else-if="props.column.field == 'data_model_id'">
                                <span>{{ findModelName(props.row.data_model_id) }}</span>
                            </span>
                            <span v-else-if="props.column.field == 'date_from'">
                                <span>Dal {{ props.row.date_from }}</span>
                                <span> al {{ props.row.date_to }}</span>
                            </span>
                            <span v-else-if="props.column.field == 'excluded_dates'">
                                <span v-for="(date, index) in props.row.excluded_dates" :key="index">
                                    {{ date }}<br>
                                </span>
                            </span>
                            <span v-else-if="props.column.field == 'action'" class="d-flex justify-content-end">
                                <b-btn class="change-button mr-2" @click="openEditModal(props.row)"><font-awesome-icon icon="cogs" /></b-btn>
                                <b-btn variant="danger" @click="openDeleteModal(props.row)"><font-awesome-icon icon="fa-times" /></b-btn>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                        <template #table-column="props">
                            {{ props.column.label }}
                        </template>
                    </vue-good-table>
                    <div class="d-flex justify-content-end mt-4">
                        <b-btn variant="primary" class="mr-2" @click="openUploadModal()">Importa CSV</b-btn>
                        <!--<b-btn variant="primary" class="mr-2" @click="exportVirtual()">Esporta CSV</b-btn>-->
                        <b-btn variant="warning" class="mr-2" @click="openEditModal()">Aggiungi utenza</b-btn>
                        <b-btn variant="primary" @click="openBulkModal()" :disabled="bulkChannels.length == 0">Operazioni bulk</b-btn>
                    </div>
                </div>
                <!-- Calendario -->
                <div v-if="tabSelected == 'calendar'" ref="fullCalendar"></div>
                <div v-if="tabSelected == 'calendar'" class="d-flex justify-content-end mt-4">
                    <b-btn class="mr-2" @click="openEditModal()">Importa EXCEL</b-btn>
                    <b-btn variant="warning" @click="openEditModal()">Aggiungi utenza</b-btn>
                </div>
                <!-- Correzioni -->
                <VirtualCorrections v-if="tabSelected == 'correction'" :siteId="siteId" />
            </div>
        </div>

        <b-modal id="uploadModal" ref="uploadModal"
            size="xl"
            hide-footer
            centered
            title="Importazione utenze"
            header-bg-variant="warning"
        >
            <div class="cnt-modal">
                <p>
                    Caricare un file CSV con il seguente formato:<br><br>
                    <ul style="list-style-type: unset">
                        <li>separatore: ; (punto e virgola)</li>
                        <li>non inserire i nomi delle colonne</li>
                        <li>i valori numerici usano il . (punto) come separatore dei decimali</li>
                        <li>le date sono in formato italiano: GG/MM/AAAA</li>
                        <li>per gli orari indicare solo l'ora, senza i minuti</li>
                        <li>i giorni della settimana iniziano dal lunedì, identificato con l'indice 1</li>
                        <li>i vettori sono codificati secondo la seguente tabella:</li>
                    </ul>
                    <table class="table table-striped virtual-data-table">
                        <tbody>
                            <tr>
                                <th>Energia elettrica</th>
                                <td>EE</td>
                            </tr>
                            <tr>
                                <th>Gas naturale</th>
                                <td>gas</td>
                            </tr>
                            <tr>
                                <th>Fluido termovettore</th>
                                <td>fluidth</td>
                            </tr>
                            <tr>
                                <th>Olio combustibile</th>
                                <td>oil</td>
                            </tr>
                            <tr>
                                <th>Temperatura</th>
                                <td>t</td>
                            </tr>
                            <tr>
                                <th>GPL</th>
                                <td>GPL</td>
                            </tr>
                            <tr>
                                <th>Gasolio</th>
                                <td>Diesel</td>
                            </tr>
                            <tr>
                                <th>CDR</th>
                                <td>CDR</td>
                            </tr>
                            <tr>
                                <th>Scarti processo lavorazione legno</th>
                                <td>spll</td>
                            </tr>
                            <tr>
                                <th>Benzine</th>
                                <td>benz</td>
                            </tr>
                            <tr>
                                <th>Acqua</th>
                                <td>water</td>
                            </tr>
                            <tr>
                                    <th>Kerosene Jet Fuel</th>
                                    <td>KJF</td>
                                </tr>
                        </tbody>
                    </table><br>
                    Le colonne sono: <br><br>
                    Nome canale, Canale padre, Vettore, Consumo, Fattore di carico, Data inizio, Data fine, Giorni settimana, Ora inizio, Ora fine<br><br>
                    Esempio di riga per un'utenza di nome "Tornio", vettore elettrico, consumo 12.5 kWh, fattore di carico 0.8, attiva dal 1 Gennaio 2023 al 31 Ottobre 2023, dal lunedì al venerdì, dalle 8:00 alle 18:00<br>
                </p>
                <div class="cnt-example">Tornio;;EE;12.5;0.8;1/1/2023;31/10/2023;1,2,3,4,5;8;18</div><br>
                <p>N.B.: non è stato specificato un canale genitore pertanto la seconda colonna è vuota</p>
            </div>
            <div class="d-flex justify-content-end mt-3">
                <b-btn class="mr-2" variant="secondary" @click="closeUploadModal()">Annulla</b-btn>
                <input type="file" @change="uploadFile" ref="file">
                <b-btn :disabled="! fileToUpload || isUploading" variant="primary" @click="submitFile()" accept=".csv">
                    <font-awesome-icon icon="cloud-upload-alt" />
                    <template v-if="isUploading">In corso...</template>
                    <template v-else>Importa</template>
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="confirmUploadModal" ref="confirmUploadModal"
            size="xs"
            hide-footer
            centered
            hide-header-close
            title="Conferma importazione utenze"
            header-bg-variant="warning"
        >
            <p>Utenze importate correttamente</p>
            <div class="d-flex justify-content-end mt-3">
                <b-btn variant="primary" @click="reloadPage()">Chiudi</b-btn>
            </div>
        </b-modal>
        
        <b-modal id="editModal" header-bg-variant="warning" size="lg" hide-footer centered :title="form.name ? 'Modifica utenza' : 'Nuova utenza'">
            <form role="form" ref="form" class="needs-validation virtual-panel" novalidate @submit.prevent="handleSubmit">
                <b-row>
                    <b-col>
                        <label class="form-label">Canale</label>
                        <v-select v-if="virtualChannels.length > 0" v-model="form.channel_code" :options="virtualChannels" :reduce="ch => ch.value" :clearable="false" />
                        <b-alert :show="virtualChannels.length == 0">Nessuna utenza disponibile.</b-alert>
                    </b-col>
                    <b-col>
                        <label class="form-label">Fattore</label>
                        <input
                            type="number"
                            class="form-control"
                            v-model="form.factor"
                            step=".01"
                            required
                        />
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <label class="form-label">Breve descrizione</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="form.description"
                        />
                    </b-col>
                    <b-col />
                </b-row>
                <label class="form-label mt-3">Periodo</label>
                <b-row>
                    <b-col>
                        <label class="form-label">dal</label>
                        <date-pick
                            v-model="form.date_from"
                            :months="monthsNames"
                            :weekdays="daysNames"
                            :selectableYearRange="5"
                            format="DD/MM/YYYY"
                        />
                    </b-col>
                    <b-col>
                        <label class="form-label">al</label>
                        <date-pick
                            v-model="form.date_to"
                            :months="monthsNames"
                            :weekdays="daysNames"
                            :selectableYearRange="5"
                            format="DD/MM/YYYY"
                        />
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Giorno</th>
                                <th scope="col">Dalle</th>
                                <th scope="col">Alle</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(day, index) in daysOption" :key="index">
                                <td>{{ day.label }}</td>
                                <td>
                                    <b-form-select class="form-control" v-model="week_timetable[index + 1].from" :options="timesOption" />
                                </td>
                                <td>
                                    <b-form-select class="form-control" v-model="week_timetable[index + 1].to" :options="timesOption" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <b-row class="mt-3">
                    <b-col style="display: grid">
                        <label class="form-label">Date escluse</label>
                        <date-pick
                            v-model="excludedDates"
                            :months="monthsNames"
                            :weekdays="daysNames"
                            :selectableYearRange="5"
                            format="DD/MM/YYYY"
                        />
                        <div class="mt-2">
                            <span class="badge badge-light mr-2" v-for="(date, index) in excludedDatesList" :key="index">
                                <div class="d-flex justify-content-between align-items-center px-1">
                                    {{ date }}
                                    <div class="close-button ml-2" @click="removeDate(date)">
                                        <font-awesome-icon icon="xmark" />
                                    </div>
                                </div>
                            </span>
                        </div>
                    </b-col>
                    <b-col />
                </b-row>
                <b-row class="mt-4">
                    <b-col class="d-flex justify-content-end">
                        <b-btn class="mr-2" variant="secondary" @click="closeModal()">Annulla</b-btn>
                        <b-btn type="submit" variant="primary">Salva</b-btn>
                    </b-col>
                </b-row>
            </form>
        </b-modal>
        
        <b-modal id="deleteModal" ref="deleteModal" centered
            title="Conferma cancellazione"
            header-bg-variant="danger"
            ok-title="Procedi"
            ok-variant="danger"
            @ok="deleteChannel()">

            <p>Procedere con la cancellazione delle impostazioni per l'utenza <b v-if="this.channelToDelete && this.channelToDelete.name">{{ this.channelToDelete.name }}</b>?</p>
        </b-modal>
        <b-modal id="bulkModal" header-bg-variant="warning" size="lg" hide-footer centered title="Modifiche bulk">
            <form role="form" ref="form" class="needs-validation virtual-panel" novalidate @submit.prevent="handleBulkSubmit">
                <b-row>
                    <b-col>
                        <label class="form-label">Canali selezionati</label>
                        <div>
                            <b-badge class="mr-1" variant="warning" v-for="channel in bulkChannels" :key="channel.is">{{ channel.name }}</b-badge>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <label class="form-label">Fattore</label>
                        <input
                            type="number"
                            class="form-control"
                            v-model="form.factor"
                            step=".01"
                        />
                    </b-col>
                    <b-col>
                            <label class="form-label">Breve descrizione</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="form.description"
                            />
                        </b-col>
                </b-row>
                <label class="form-label mt-3">Periodo</label>
                <b-row>
                    <b-col>
                        <label class="form-label">dal</label>
                        <date-pick
                            v-model="form.date_from"
                            :months="monthsNames"
                            :weekdays="daysNames"
                            :selectableYearRange="5"
                            format="DD/MM/YYYY"
                        />
                    </b-col>
                    <b-col>
                        <label class="form-label">al</label>
                        <date-pick
                            v-model="form.date_to"
                            :months="monthsNames"
                            :weekdays="daysNames"
                            :selectableYearRange="5"
                            format="DD/MM/YYYY"
                        />
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <p>E' possibile impostare singoli giorni o singoli orari (es.: impostare solo il campo "Alle" del giovedì)</p>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Giorno</th>
                                <th scope="col">Dalle</th>
                                <th scope="col">Alle</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(day, index) in daysOption" :key="index">
                                <td>{{ day.label }}</td>
                                <td>
                                    <b-form-select class="form-control" v-model="week_timetable[index + 1].from" :options="timesOption" />
                                </td>
                                <td>
                                    <b-form-select class="form-control" v-model="week_timetable[index + 1].to" :options="timesOption" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <b-row class="mt-4">
                    <b-col class="d-flex justify-content-end">
                        <b-btn class="mr-2" variant="secondary" @click="closeBulkModal()">Annulla</b-btn>
                        <b-btn type="submit" variant="primary">Salva</b-btn>
                    </b-col>
                </b-row>
            </form>
        </b-modal>
    </section>
</template>

<script>
import FileUpload from 'vue-upload-component'
import api from '@/services/api';
import PageMixin from "../../Charts/PageMixin";
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import moment from 'moment';
import vSelect from 'vue-select';
import VirtualCorrections from "./VirtualCorrections.vue";
import axios from 'axios';

var VueCookie = require("vue-cookie");

export default {
    name: "Virtual",
    mixins: [PageMixin],
    components: { VueGoodTable, vSelect, VirtualCorrections, FileUpload },
    props: ['siteId'],
    computed: {
        daysNames() {
            return this.$store.state.utils.daysShort;
        },
        virtualChannels() {
            let result = [];

            this.$store.state.sites.current.channels.forEach(item => {  
                if (item.is_virtual == 1 && item.data_model_id == 1) {
                    result.push({ label: item.name, value: item.code });
                }
            })
            return result.sort((a, b) => a.label - b.label);
        },
        headers() {
            return {
                Authorization: VueCookie.get("token"),
            };
        },
    },
    data() {
        return {
            tabSelected: 'list',
            rows: [],
            filteredRows: [],
            columns: [
                {
                    label: 'Nome canale',
                    field: 'name',
                    sortable: true
                },
                {
                    label: 'Fattore',
                    field: 'factor',
                    sortable: true
                },
                {
                    label: 'Modello',
                    field: 'data_model_id',
                    sortable: true
                },
                {
                    label: 'Periodo',
                    field: 'date_from',
                    sortable: false
                },
                {
                    label: 'Date escluse',
                    field: 'excluded_dates',
                    sortable: false
                },
                {
                    label: '',
                    field: 'action',
                    sortable: false
                },
            ],
            form: {},
            timesOption: [],
            daysOption: [],
            excludedDates: "",
            excludedDatesList: [],
            channelToDelete: {},
            calendar: null,
            week_timetable: {},
            files: [],
            fileToUpload: null,
            isUploading: false,
            isImporting: false,
            filterVirtual: null,
            modelOptions: [],
            bulkChannels: []
        }
    },
    async created() {
        this.$store.commit("loading");

        moment.locale('it');
        this.loadTimesOption();
        this.loadDaysOptions();
        this.loadWeekDays();
        await this.loadChannels();
        this.loadDataModels();

        this.$store.commit("stopLoading");
    },
    methods: {
        selectedRowsChange(data) {
            this.bulkChannels = [...data.selectedRows];            
        },
        exportVirtual() {
            let virtualData = [];
            virtualData.push([
                "name",
                "parent_name",
                "vector",
                "virtual_value",
                "factor",
                "date_from",
                "date_to",
                "week_days",
                "hour_from",
                "hour_to",
            ]);

            this.filteredRows.forEach((item) => {
                const channel = this.$store.state.sites.current.channels.find(ch => ch.code == item.channel_code && ch.data_model_id == 1);
                const parent_channel = this.$store.state.sites.current.channels.find(ch => ch.code == item.parent_code && ch.data_model_id == 1);

                let week_days = [];
                let time_from = null;
                let time_to = null;

                item.week_timetable.forEach(wt => {
                    if(wt.from && wt.to && ! week_days.includes(wt.day)) {
                        week_days.push(wt.day);
                    }
                    if(! time_from) {
                        time_from = wt.from;
                    }
                    if(! time_to) {
                        time_to = wt.to;
                    }
                })

                virtualData.push([
                    item.name,
                    parent_channel && parent_channel.name ? parent_channel.name : null,
                    channel && channel.vector ? channel.vector : null,
                    channel && channel.virtual_value ? channel.virtual_value : null,
                    item.factor,
                    item.date_from,
                    item.date_to,
                    week_days.join(","),
                    time_from,
                    time_to,
                ]);
            });

            virtualData = virtualData.map(row => {
                return row.join(";"); 
            })

            var downloadLink = document.createElement("a");
            downloadLink.href =
                "data:text/csv;charset=utf-8," + encodeURI(virtualData.join("\n"));
            downloadLink.download = "export-virtual-data.csv";
            document.body.appendChild(downloadLink);
            downloadLink.innerHTML = "DOWNLOAD";
            downloadLink.click();
            document.body.removeChild(downloadLink);
        },
        findModelName(id) {
            const model = this.modelOptions.find(item => item.id == id);

            if(! model) {
                return null;
            }

            return model.name;
         },
        loadDataModels() {
            this.$store.dispatch('sites/dataModels', this.$route.params.guid).then((models) => {
                if (Array.isArray(models)) {
                    this.modelOptions = models;
                }
            });
        },
        filterList() {
            if(!this.filterVirtual) {
                this.filteredRows = [ ...this.rows ];
            } else {
                const filter = this.filterVirtual.toLowerCase();

                this.filteredRows = this.rows.filter(item => {
                    if(item.name.toLowerCase().indexOf(filter) > -1) {
                        return true;
                    }
                    if(item.channel_code.toLowerCase().indexOf(filter) > -1) {
                        return true;
                    }
                    return false;
                })
            }
        },
        reloadPage() {
            location.reload();
            /*await this.loadChannels();
            this.$emit('reload');
            this.$bvModal.hide("uploadModal");*/
        },
        closeUploadModal() {
            this.$nextTick(() => {
                this.$bvModal.hide("uploadModal");
                this.fileToUpload = null;
            });
        },
        openUploadModal() {
            this.$nextTick(() => {
                this.$bvModal.show("uploadModal");
            });
        },
        uploadFile() {
            this.isUploading = true;

            const extension = this.$refs.file.files[0].name.split(".")[1];
            if(extension != "csv") {
                this.$notify({
                    type: "error",
                    text: "Estensione non valida",
                    title: 'Errore',
                });
            } else {
                this.fileToUpload = this.$refs.file.files[0];
            }

            this.isUploading = false;
        },
        submitFile() {
            this.isUploading = true;

            const formData = new FormData();
            formData.append('file', this.fileToUpload);
            const headers = { 'Content-Type': 'multipart/form-data' };
            axios.post(`/api/v1/virtual-data/${this.$route.params.guid}/upload`, formData, { headers }).then(async (res) => {
                this.isUploading = false;
                if (res.data.code == 1) {
                    this.$notify({
                        type: "success",
                        text: "Utenza importata con successo",
                        title: "Successo",
                    });

                    this.fileToUpload = null;

                    this.$nextTick(() => {
                        this.$bvModal.show("confirmUploadModal");
                        this.$bvModal.hide("uploadModal");
                    });
                } else {
                    this.$notify({
                        type: "error",
                        text: res.data.message,
                        title: 'Errore',
                    });
                }
            });            
        },
        closeModal() {
            this.loadWeekDays();
            this.excludedDates = "";
            this.excludedDatesList = [];
            this.$nextTick(() => {
                this.$bvModal.hide('editModal');
            });
        },
        nextAvailableDay(day, exclDates, exclWeekDays) {
            day = moment(day, "DD/MM/YYYY").add(1, "d");
            while(true) {
                if(exclDates.includes(day)
                || exclWeekDays.includes(moment(day, "DD/MM/YYYY").isoWeekday().toString())) {
                    day = moment(day, "DD/MM/YYYY").add(1, "d").format("DD/MM/YYYY");
                } else {
                    return moment(day, "DD/MM/YYYY").format("DD/MM/YYYY");
                }
            }
        },
        openCalendar() {
            this.tabSelected = "calendar";
            let eventsList = [];
            let channelCodes = {}; //to set same color for same channel code

            this.rows.forEach((row, index) => {
                let startDate = row.date_from;
                let endDate = row.date_from;

                let excludedDays = [];

                if(! channelCodes[row.channel_code]) {
                    channelCodes[row.channel_code] = this.$store.state.colors[index];
                }

                let title = `${row.name}`;
                if(row.description) {
                    title += ` (${row.description})`;
                }

                while(true) {
                    if(row.excluded_dates && (row.excluded_dates.includes(endDate)
                    || excludedDays.includes(moment(endDate, "DD/MM/YYYY").isoWeekday().toString()))) {
                        if(moment(startDate, "DD/MM/YYYY").format("YYYY-MM-DD") != moment(endDate, "DD/MM/YYYY").format("YYYY-MM-DD")) {
                            eventsList.push({
                                title: title,
                                start: moment(startDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                                end: moment(endDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                                backgroundColor: channelCodes[row.channel_code]
                            });
                        }

                        startDate = this.nextAvailableDay(endDate, row.excluded_dates, excludedDays);
                        endDate = moment(startDate, "DD/MM/YYYY").add(1, 'd').format("DD/MM/YYYY");
                    } else {
                        endDate = moment(endDate, "DD/MM/YYYY").add(1, 'd').format("DD/MM/YYYY");
                    }
                    if(moment(endDate, "DD/MM/YYYY").isSameOrAfter(moment(row.date_to, "DD/MM/YYYY"))) {
                        eventsList.push({
                            title: title,
                            start: moment(startDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                            end: moment(endDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                            backgroundColor: channelCodes[row.channel_code]
                        });
                        break;
                    }
                }
            })

            this.$nextTick(() => {
                this.calendar = this.$refs.fullCalendar;

                var calendar = new FullCalendar.Calendar(this.calendar, {
                    initialView: 'dayGridMonth',
                    events: eventsList
                });
                calendar.setOption('locale', 'it');
                calendar.render();
            });
        },
        async deleteChannel() {
            this.$store.commit("loading");
            try {
                const data = await api().delete(`/customer/site/channel/virtual/delete/${this.channelToDelete.id}`);
                if(data.data.code == 1) {
                    this.$notify({
                        type: "success",
                        text: "Utenza eliminata con successo",
                        title: "Successo",
                    });
                }
                await this.loadChannels();
                this.$nextTick(() => {
                    this.$bvModal.hide("editModal");
                    this.$bvModal.hide("deleteModal");
                });
                this.$store.commit("stopLoading");
            } catch(e) {
                this.$notify({
                    type: "error",
                    text: e.message,
                    title: 'Errore',
                });
                this.$store.commit("stopLoading");
            }
        },
        openDeleteModal(data) {
            this.$nextTick(() => {
                this.$bvModal.hide("editModal");
                this.$bvModal.show("deleteModal");
            });
            this.channelToDelete = data;
        },
        removeDate(date) {
            this.excludedDatesList = this.excludedDatesList.filter(item => item != date);
        },
        async submit() {
            this.$store.commit("loading");
            try {
                const result = {};
                result.channel_code = this.form.channel_code;
                result.site_guid = this.$route.params.guid;
                result.description = this.form.description;
                result.factor = parseFloat(this.form.factor);
                result.date_from = moment(this.form.date_from, "DD/MM/YYYY").format("YYYY-MM-DD");
                result.date_to = moment(this.form.date_to, "DD/MM/YYYY").format("YYYY-MM-DD");
                result.id = this.form.id;
                result.week_timetable = [];

                let stringDates = "";
                if(this.excludedDatesList && this.excludedDatesList.length > 0) {
                    this.excludedDatesList.forEach((item, index) => {
                        stringDates += moment(item, "DD/MM/YYYY").format("YYYY-MM-DD");
                        if(index < this.excludedDatesList.length - 1) {
                            stringDates += ",";
                        }
                    });
                }
                result.excluded_dates = stringDates;

                for (const [key, value] of Object.entries(this.week_timetable)) {
                    result.week_timetable.push(value);
                }

                const data = await api().post(`/customer/site/virtual/edit`, result);
                if(data.data.code == 1) {
                    if(this.form.name) {
                        this.$notify({
                            type: "success",
                            text: "Utenza modificata con successo",
                            title: "Successo",
                        });
                    } else {
                        this.$notify({
                            type: "success",
                            text: "Utenza creata con successo",
                           title: "Successo",
                        });
                    }
                } else {
                    this.$notify({
                        type: "error",
                        text: data.data.message,
                        title: "Errorew",
                    });
                }
                await this.loadChannels();
                this.$nextTick(() => {
                    this.$bvModal.hide("editModal");
                });
                this.$store.commit("stopLoading");
            } catch(e) {
                this.$notify({
                    type: "error",
                    text: e.message,
                    title: 'Errore',
                });
                this.$store.commit("stopLoading");
            }
        },
        async bulkSubmit() {
            this.$store.commit("loading");
            try {
                const request = {};
                request.channelCodes = this.bulkChannels.map(_ => _.channel_code);
                request.siteGuid = this.$route.params.guid;
                request.description = this.form.description;
                request.factor = this.form.factor ? parseFloat(this.form.factor) : null;
                request.fromDate = this.form.date_from ?
                    moment(this.form.date_from, "DD/MM/YYYY").format("YYYY-MM-DD") : null;
                request.toDate = this.form.date_to ?
                    moment(this.form.date_to, "DD/MM/YYYY").format("YYYY-MM-DD") : null;
                request.weekTimetable = {
                    days: []
                };

                for (const [key, value] of Object.entries(this.week_timetable)) {
                    if (value.from >= 0 || value.to >= 0) {
                        request.weekTimetable.days.push(value);   
                    }                    
                }

                const data = await api().post(`/customer/site/virtual/bulk`, request);
                if (data.data.code == 1) {                    
                    this.$notify({
                        type: "success",
                        text: "Utenze modificate con successo",
                        title: "Successo",
                    });
                    this.$nextTick(() => {
                        this.$bvModal.hide("bulkModal");
                    });
                    await this.loadChannels();
                } else {
                    this.$notify({
                        type: "error",
                        text: data.data.message,
                        title: "Errore",
                    });
                }                
                
                this.$store.commit("stopLoading");
            } catch (e) {
                this.$notify({
                    type: "error",
                    text: e.message,
                    title: 'Errore',
                });
                this.$store.commit("stopLoading");
            }
        },
        isNotNull(number) {
            if(number == null) {
                return false;
            }

            return true;
        },
        async handleSubmit() {
            if(! this.$refs.form.checkValidity()) {
                this.$refs.form.classList.add('was-validated');
                this.$notify({
                    type: "error",
                    text: "Compilare i campi obbligatori",
                    title: "Errore"
                });
                return;
            }
            if(! this.form.channel_code) {
                this.$notify({
                    type: "error",
                    text: "Inserire il codice canale",
                    title: "Errore"
                });
                return;
            }
            if(! this.form.date_from) {
                this.$notify({
                    type: "error",
                    text: "Inserire la data di inizio",
                    title: "Errore"
                });
                return;
            }
            if(! this.form.date_to) {
                this.$notify({
                    type: "error",
                    text: "Inserire la data di fine",
                    title: "Errore"
                });
                return;
            }

            let counterDayNull = 0;

            for (const [key, value] of Object.entries(this.week_timetable)) {
                if(this.isNotNull(value.from) && this.isNotNull(value.to)) {
                    if(value.from >= value.to) {
                        this.$notify({
                            type: "error",
                            text: "Orario giornaliero non valido",
                            title: "Errore"
                        });
                        return;
                    }
                }

                if((this.isNotNull(value.from) && ! this.isNotNull(value.to))
                || (! this.isNotNull(value.from) && this.isNotNull(value.to))) {
                    this.$notify({
                        type: "error",
                        text: "Orario giornaliero non valido",
                        title: "Errore"
                    });
                    return;
                }

                if(! this.isNotNull(value.from) && ! this.isNotNull(value.to)) {
                    counterDayNull++;
                }
            }

            if(counterDayNull > 6) {
                this.$notify({
                    type: "error",
                    text: "Orari assenti. E' necessario indicare l'orario di attività dell'utenza per almeno un giorno della settimana",
                    title: "Errore"
                });
                return;
            }

            if(moment(this.form.date_from, "DD/MM/YYYY").isAfter(moment(this.form.date_to, "DD/MM/YYYY"))) {
                this.$notify({
                    type: "error",
                    text: "La data di inizio deve essere precedente a quella di fine",
                    title: "Errore"
                });
                return;
            }

            await this.submit();
        },
        async handleBulkSubmit() {
            if (!this.$refs.form.checkValidity()) {
                this.$refs.form.classList.add('was-validated');
                this.$notify({
                    type: "error",
                    text: "Compilare i campi obbligatori",
                    title: "Errore"
                });
                return;
            }
            if (this.bulkChannels.length == 0) {
                this.$notify({
                    type: "error",
                    text: "Selezionare le utenze",
                    title: "Errore"
                });
                return;
            }

            for (const [key, value] of Object.entries(this.week_timetable)) {
                if (this.isNotNull(value.from) && this.isNotNull(value.to)) {
                    if (value.from >= value.to) {
                        this.$notify({
                            type: "error",
                            text: "Orario giornaliero non valido",
                            title: "Errore"
                        });
                        return;
                    }
                }
            }

            if (this.form.date_from && this.form.date_to &&
                moment(this.form.date_from, "DD/MM/YYYY").isAfter(moment(this.form.date_to, "DD/MM/YYYY"))) {
                this.$notify({
                    type: "error",
                    text: "La data di inizio deve essere precedente a quella di fine",
                    title: "Errore"
                });
                return;
            }

            await this.bulkSubmit();
        },
        formatExcludedDates(excluded_dates) {
            const dates = excluded_dates.split(",");
            return dates.map(date => this.formatDate(date));
        },
        formatDate(date) {
            return moment(date).format("DD/MM/yyyy");
        },
        openBulkModal() {
            this.form = {};
            for (let i = 1; i <= 7; i++) {
                this.week_timetable[i] = { day: i }
            }
            this.$nextTick(() => {
                this.$bvModal.show("bulkModal");
            });
        },
        closeBulkModal() {
            this.$nextTick(() => {
                this.$bvModal.hide('bulkModal');
            });
        },
        openEditModal(data) {
            this.excludedDatesList = [];
            this.form = {};
            if(data) {
                this.form = data;
                if(this.form.excluded_dates != null) {
                    this.form.excluded_dates.forEach(item => {
                        if(item) {
                            this.excludedDatesList.push(item);
                        }
                    })
                }
                for (let i = 1; i <= 7; i++) {
                    this.week_timetable[i] = { day: i }
                }
                this.form.week_timetable.forEach(item => {
                    this.week_timetable[item.day].from = item.from;
                    this.week_timetable[item.day].to = item.to;
                })            
            }
            this.$nextTick(() => {
                this.$bvModal.show("editModal");
            });
        },
        async loadChannels() {
            try {
                const data = await api().get(`/customer/site/${this.$route.params.guid}/virtual/list`);
                this.rows = data.data.data;
                this.rows = this.rows.map(item => {
                    item.date_from = moment(item.date_from, "YYYY/MM/DD").format("DD/MM/YYYY");
                    item.date_to = moment(item.date_to, "YYYY/MM/DD").format("DD/MM/YYYY");
                    if(item.excluded_dates) {
                        item.excluded_dates = this.formatExcludedDates(item.excluded_dates);
                    }
                    return item;
                })
                this.filteredRows = [ ...this.rows ];
            } catch(e) {
                this.$notify({
                    type: "error",
                    text: e.message,
                    title: 'Errore',
                });
            }
        },
        loadTimesOption() {
            this.timesOption.push({ text: "--", value: null });
            for(let i = 0; i < 25; i++) {
                this.timesOption.push({ text: i, value: i });
            }
        },
        loadWeekDays() {
            this.week_timetable = {};
            for(let i = 0; i < 7; i++) {
                this.week_timetable[i + 1] = { day: i + 1, from: null, to: null };
            }
        },
        loadDaysOptions() {
            for(let i = 0; i < 7; i++) {
                const day = moment().weekday(i).format("dddd").toString();
                this.daysOption.push({ label: day.charAt(0).toUpperCase() + day.slice(1), value: i + 1 });
            }
        },
    },
    watch: {
        excludedDates() {
            if(this.excludedDates && ! this.excludedDatesList.includes(this.excludedDates)) {
                this.excludedDatesList.push(this.excludedDates);
            }
        }
    }
}
</script>

<style scoped>
.virtual-data-table {
    max-width: 400px;
    margin-left: 20px;
}
.cnt-modal {
    max-height: 65vh;
    overflow: auto;
}
.cnt-example {
    font-family: Courier, monospace;
    background: #f0f0f0;
    padding: 2px;
}
</style>

<style>
.virtual-panel .vdpComponent input {
    min-width: 200px;
    width: 200px;
    border: 1px solid #ced4da;
    display: inline-block;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
</style>

<style scoped>
.tab {
    padding: 8px 10px;
    color: #4f5f6f;
    font-size: 14px;
    cursor: pointer;
}
.tab-selected {
    border-top: 2px solid #4499AD;
    background: #ffffff;
}
.tabs-bar {
    display: flex;
    background: #f7f7f7;
    margin-bottom: 30px;
}
.close-button {
    color: red;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Sites/Virtual.vue